import {IComponentOptions, IFormController} from 'angular';
import TSAdresse from '../../../models/TSAdresse';
import ITranslateService = angular.translate.ITranslateService;

require('./dv-adresse.scss');

export class AdresseComponentConfig implements IComponentOptions {
    transclude = false;
    bindings: any = {
        adresse: '=',
        bisherFs: '<?',
        bisherGs: '<?',
        prefix: '@',

    };
    template = require('./dv-adresse.html');
    controller = DvAdresseController;
    controllerAs = 'vm';
    require: any = {parentForm: '?^form'};
}

export class DvAdresseController {
    static $inject = ['$translate'];

    adresse?: TSAdresse;
    bisherFs: any;
    bisherGs: any;
    prefix: string;
    $translate: ITranslateService;
    parentForm: IFormController;

    /* @ngInject */
    constructor($translate: ITranslateService) {
        this.$translate = $translate;
    }

    resetForm() {
        this.adresse = undefined;
    }

    public getModel(): TSAdresse | undefined {
        return this.adresse;
    }

    public showBisher(): boolean {
        return (this.bisherFs !== undefined && this.bisherGs !== undefined);
    }

    public displayLegacyAdresse(): boolean {
        return this.adresse!.adresse1 === undefined || this.adresse!.adresse1 === null;
    }

}




// WEBPACK FOOTER //
// ./src/app/core/component/dv-adresse/dv-adresse.ts